import { render, staticRenderFns } from "./EmailConfirmed.vue?vue&type=template&id=c5803a44&scoped=true&"
import script from "./EmailConfirmed.vue?vue&type=script&lang=js&"
export * from "./EmailConfirmed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5803a44",
  null
  
)

export default component.exports